export default "__VITE_ASSET__4af28c74__"